import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { buildStructuredDataGraph } from "@/config/buildStructuredData";

/** Find in DevTools → Elements → search `duri-structured-data` (not View Page Source). */
export const STRUCTURED_DATA_SCRIPT_ID = "duri-structured-data";
const SCRIPT_ID = STRUCTURED_DATA_SCRIPT_ID;

/** Legacy per-page script IDs/selectors to remove when central schema takes over. */
const LEGACY_SCRIPT_IDS = ["ld-corridor-hyd-vja", "duri-article-jsonld"];
const LEGACY_SCRIPT_ATTRS = ["data-available-rides-ld", "data-waiting-guests-ld"];

function removeLegacyScripts() {
  LEGACY_SCRIPT_IDS.forEach((id) => document.getElementById(id)?.remove());
  LEGACY_SCRIPT_ATTRS.forEach((attr) => {
    document.querySelector(`script[${attr}]`)?.remove();
  });
}

/**
 * Injects a single schema.org JSON-LD @graph per route — WebSite, Organization,
 * BreadcrumbList, ItemList, FAQPage, ContactPoint, and corridor-specific types.
 */
export function StructuredDataSync() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    removeLegacyScripts();

    const existing = document.getElementById(SCRIPT_ID);
    existing?.remove();
    // Static fallback from index.html on homepage — replaced when SPA schema loads
    document.getElementById("duri-structured-data-static")?.remove();

    try {
      const graph = buildStructuredDataGraph(pathname);
      if (!graph?.length) return;

      const script = document.createElement("script");
      script.id = SCRIPT_ID;
      script.type = "application/ld+json";
      script.setAttribute("data-duri-schema", "route");
      script.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@graph": graph,
      });
      document.head.appendChild(script);
    } catch (error) {
      console.error("[StructuredDataSync] Failed to inject JSON-LD:", error);
    }

    return () => {
      document.getElementById(SCRIPT_ID)?.remove();
    };
  }, [pathname]);

  return null;
}
